export class PetRabieDetailsModel {
    pet_no: number;
    rabie_tag_no: string;
    rabie_vacc_no: string;
    rabie_vacc_date: string; // Using string for date to match common API formats
    rabie_doctor: string;
    rabie_clinic: number;
    rabie_year: number;
    vaccine_no: string;
    vaccine_manuf: string;
    vaccine_type: string;
    vaccine_batch_no: string;
    vaccine_expire: string; // Using string for date
    vaccine_name: string;
    vaccine_active: boolean;
    vaccine_use: string;
    vaccine_clinic: number;
    doctor_desc: string;
    clinic_desc: string;

    constructor(
        pet_no: number = 0,
        rabie_tag_no: string = '',
        rabie_vacc_no: string = '',
        rabie_vacc_date: string = '',
        rabie_doctor: string = '',
        rabie_clinic: number = 0,
        rabie_year: number = 0,
        vaccine_no: string = '',
        vaccine_manuf: string = '',
        vaccine_type: string = '',
        vaccine_batch_no: string = '',
        vaccine_expire: string = '',
        vaccine_name: string = '',
        vaccine_active: boolean = false,
        vaccine_use: string = '',
        vaccine_clinic: number = 0,
        doctor_desc: string = '',
        clinic_desc: string = ''
    ) {
        this.pet_no = pet_no;
        this.rabie_tag_no = rabie_tag_no;
        this.rabie_vacc_no = rabie_vacc_no;
        this.rabie_vacc_date = rabie_vacc_date;
        this.rabie_doctor = rabie_doctor;
        this.rabie_clinic = rabie_clinic;
        this.rabie_year = rabie_year;
        this.vaccine_no = vaccine_no;
        this.vaccine_manuf = vaccine_manuf;
        this.vaccine_type = vaccine_type;
        this.vaccine_batch_no = vaccine_batch_no;
        this.vaccine_expire = vaccine_expire;
        this.vaccine_name = vaccine_name;
        this.vaccine_active = vaccine_active;
        this.vaccine_use = vaccine_use;
        this.vaccine_clinic = vaccine_clinic;
        this.doctor_desc = doctor_desc;
        this.clinic_desc = clinic_desc;
    }
} 